export enum PatientDataError {
    generalError = 'generalError',
    invalidUrl = 'invalidUrl',
    noDataAvailable = 'noDataAvailable',
    procedureSent = 'procedureSent',
}
